import { render, staticRenderFns } from "./NewsPlugin.vue?vue&type=template&id=1e778d2c&scoped=true&"
import script from "./NewsPlugin.vue?vue&type=script&lang=js&"
export * from "./NewsPlugin.vue?vue&type=script&lang=js&"
import style0 from "./NewsPlugin.vue?vue&type=style&index=0&id=1e778d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e778d2c",
  null
  
)

export default component.exports